import React from 'react'
import Title from '../../../Common/Title'
import bg from "../../../../Assets/Images/map-platform.png"
import img from "../../../../Assets/Images/_e-img-platform-stats.448717bff4353eedd785_jp.png"
import item1 from "../../../../Assets/Images/ic-platform-stats-01@3x.png"
import item2 from "../../../../Assets/Images/ic-platform-stats-02@3x.png"
import item3 from "../../../../Assets/Images/ic-platform-stats-03@3x.png"
import "./styles.scss"

function PlatformMap() {
  return (
    <div className='platformMap'>
        
        <div className="platformMap-bg">
            <img src={bg} alt="" />
        </div>

        <div className="platformMap-container">
        <Title title={<>{`統計機能`}</>} />
        <div className="map">
            <img src={img} alt="" />
        </div>
        <div className="map-list">
          {dataMap.map((item,index) => (
            <div className="item" key={index}>
              <div className="img">
                <img src={item.img} alt="" />
              </div>
              <div className="content">
                <div className="title1">{item.title}</div>
                <div className="detail1">{item.detail}</div>
              </div>
            </div>
          ))}
        </div>
        </div>
    </div>
  )
}

export default PlatformMap

const dataMap = [
    {
      img: item1,
      title: '一目で把握できる統計',
      detail: 'グラフで全体統計を確認\n\n'
    },
    {
      img: item2,
      title: 'エクセルファイル個別所蔵',
      detail: '統計データをエクセルで\nダウンロード'
    },
    {
      img: item3,
      title: '様々な統計提供',
      detail: '仕事/カテゴリ/相談員/評点/\nレビュー別など'
    },
]